import { Routes } from '@angular/router';

import { BillingFaqComponent } from '../components/billing-faq/billing-faq.component';
import { ClaimsFaqComponent } from '../components/claims-faq/claims-faq.component';
import { GoPaperlessFaqComponent } from '../components/go-paperless-faq/go-paperless-faq.component';
import { PolicyFaqComponent } from '../components/policy-faq/policy-faq.component';

export const FaqRoutes: Routes = [
  {
    path: '',
    data: {
      breadcrumb: 'FAQ'
    },
    children: [
      { path: '', redirectTo: 'policy', pathMatch: 'full' },
      {
        path: 'go-paperless',
        component: GoPaperlessFaqComponent,
        data: { breadcrumb: 'Go Paperless' }
      },
      { path: 'policy', component: PolicyFaqComponent, data: { breadcrumb: 'Policy' } },
      { path: 'claims', component: ClaimsFaqComponent, data: { breadcrumb: 'Claims' } },
      { path: 'billing', component: BillingFaqComponent, data: { breadcrumb: 'Billing' } }
    ]
  }
];
